import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { CandidateResume } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { RESUME_ACTIONS } from '../types/ResumeActionTypes';

interface ResumeHeaderAndActionsProps {
  resume: CandidateResume;
  resumeAction: (args1: RESUME_ACTIONS, args2: string, arg3?: string) => void;
  isDeletable?: boolean;
}

const ResumeHeaderAndActions: FC<ResumeHeaderAndActionsProps> = ({
  resume,
  resumeAction,
  isDeletable = true,
}) => {
  return (
    <Grid display="flex" flexDirection="row" columnGap={1} mb={2}>
      <WsTypography variant={WsTypoVariants.BODY1} bold>
        {resume?.resumeFileName ?? ''}
      </WsTypography>
      <FileDownloadOutlinedIcon
        onClick={() =>
          resumeAction(
            RESUME_ACTIONS.DOWNLOAD,
            resume?.resumeLocation ?? '',
            resume?.resumeFileName ?? ''
          )
        }
        sx={{ color: WsColors.TheBlues500, fontSize: 24, cursor: 'pointer' }}
      />
      <VisibilityOutlinedIcon
        onClick={() => resumeAction(RESUME_ACTIONS.VIEW, resume?.resumeLocation ?? '')}
        sx={{ color: WsColors.TheBlues500, fontSize: 24, cursor: 'pointer' }}
      />
      {isDeletable && (
        <CloseIcon
          onClick={() => resumeAction(RESUME_ACTIONS.DELETE, resume?.resumeLocation ?? '')}
          sx={{ color: WsColors.Red500, fontSize: 24, cursor: 'pointer' }}
        />
      )}
    </Grid>
  );
};

export default ResumeHeaderAndActions;
